/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ProblemDetails, ProjectSceneCodeResponseDto } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Code<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Get a scene or a project based on given code
   *
   * @tags Projects
   * @name CodeDetail
   * @summary Get a scene or a project based on given code
   * @request GET:/code/{code}
   * @secure
   */
  codeDetail = (code: string, params: RequestParams = {}) =>
    this.request<ProjectSceneCodeResponseDto, ProblemDetails | void>({
      path: `/code/${code}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
